import NetworkHandler from 'utils/network';
import config from 'config';

function getMonthlyTicketPrices({ route_id, is_valid_price_vat }) {
    return NetworkHandler.get(`${config.getUrl('bus_route_subscription')}/routes/${route_id}`, {
        params: {
            page: 0,
            size: 100,
            is_valid_price_vat: is_valid_price_vat,
            source: 'web-admin'
        }
    });
}

function getMemberSubscriptionList(memberId, orderType = 1) {
    return NetworkHandler.get(`${config.getUrl('bus_subscription_order')}/members/${memberId}`, {
        params: {
            page: 0,
            size: 100,
            order_type: orderType
        }
    });
}

function getSubscription(subscriptionId) {
    return NetworkHandler.get(`${config.getUrl('bus_subscriptions')}/${subscriptionId}`);
}

function getMonthlyTicketPriceMultipleByName({ multiple_routes_name, org_id, is_valid_price_vat }) {
    return NetworkHandler.get(`${config.getUrl('bus_route_subscription')}/routes/multiple/name`, {
        params: {
            multiple_routes_name,
            org_id,
            is_valid_price_vat: is_valid_price_vat,
            source: 'web-admin'
        }
    });
}

export default {
    getMonthlyTicketPrices,
    getMemberSubscriptionList,
    getSubscription,
    getMonthlyTicketPriceMultipleByName,
};

